export enum SendStateType {
	new = "new",
	pending = "pending",
	sent = "sent",
	failed = "failed",
}
